/**
 * 学生相关路由配置
 */
export default [
  {
    path: '/student/login',
    name: 'StudentLogin',
    component: () => import('@/views/student/login.vue'),
    meta: { title: '学生登录' }
  },
  {
    path: '/student/home',
    name: 'StudentHome',
    component: () => import('@/views/student/home.vue'),
    meta: { title: '学生中心首页' }
  },
  {
    path: '/student/settings',
    name: 'StudentSettings',
    component: () => import('@/views/student/settings.vue'),
    meta: { title: '设置' }
  },
  {
    path: '/student/exam-list',
    name: 'StudentExamList',
    component: () => import('@/views/student/exam/list.vue'),
    meta: { title: '考试报名列表' }
  },
  {
    path: '/student/exam-detail',
    name: 'StudentExamDetail',
    component: () => import('@/views/student/exam/detail.vue'),
    meta: { title: '考试报名详情' }
  },
  {
    path: '/student/exam-result',
    name: 'StudentExamResult',
    component: () => import('@/views/student/exam/result.vue'),
    meta: { title: '考试报名结果' }
  },
  {
    path: '/student/exam-pay-status',
    name: 'StudentExamPayStatus',
    component: () => import('@/views/student/exam/pay-status.vue'),
    meta: { title: '考试支付状态' }
  },
  {
    path: '/student/exam-pay-proxy',
    name: 'StudentExamPayProxy',
    component: () => import('@/views/student/exam/pay-proxy.vue'),
    meta: { title: '好友代付' }
  },
  {
    path: '/student/exam-pay-proxy-status',
    name: 'StudentExamPayProxyStatus',
    component: () => import('@/views/student/exam/pay-proxy-status.vue'),
    meta: { title: '代付结果' }
  },
  {
    path: '/student/service/add',
    name: 'StudentServiceAdd',
    component: () => import('@/views/student/service/add.vue'),
    meta: { title: '添加服务' }
  },
  {
    path: '/student/service/list',
    name: 'StudentServiceList',
    component: () => import('@/views/student/service/list.vue'),
    meta: { title: '我的服务' }
  }
]
